import React from "react";
import { Link } from "react-router-dom";
import { EuStars } from "./EuStars";
import { openCookiePreferences } from "../lib/cookieConsent";
import { useLang, LangSwitcher } from "../lib/i18n";

const COLUMNS = [
    {
        title: "Product",
        tr: "Ürün",
        testid: "footer-col-product",
        items: [
            { to: "/app/research", label: "Research Assistant", tr: "Araştırma Asistanı" },
            { to: "/app/case-law", label: "Case Law Explorer", tr: "İçtihat Gezgini" },
            { to: "/app/compliance", label: "Compliance Checker", tr: "Uyum Kontrolü" },
            { to: "/app/regulatory", label: "Regulatory Intelligence", tr: "Mevzuat Takibi" },
            { to: "/app/watchdogs", label: "Watchdogs & Alerts", tr: "Takipçiler ve Uyarılar" },
            { to: "/pricing", label: "Pricing", tr: "Fiyatlandırma" },
        ],
    },
    {
        title: "Company",
        tr: "Şirket",
        testid: "footer-col-company",
        items: [
            { to: "/about", label: "About", tr: "Hakkımızda" },
            { to: "/security", label: "Security", tr: "Güvenlik" },
        ],
    },
    {
        title: "Legal",
        tr: "Hukuki",
        testid: "footer-col-legal",
        items: [
            { to: "/privacy", label: "Privacy Policy", tr: "Gizlilik Politikası" },
            { to: "/legal", label: "Terms", tr: "Kullanım Koşulları" },
            { to: "/refunds", label: "Refund Policy", tr: "İade Politikası" },
        ],
    },
];

export default function SiteFooter() {
    const { T } = useLang();
    const year = new Date().getFullYear();
    return (
        <footer className="bg-[#0D1B3E] text-[#F5F0E8] mt-auto" data-testid="site-footer">
            <div className="container-edit py-12 lg:py-14">
                <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
                    <div>
                        <Link
                            to="/"
                            className="inline-flex items-center gap-3 hover:text-[#C9A84C] transition-colors"
                            data-testid="footer-brand"
                        >
                            <EuStars size={28} />
                            <span className="font-display text-xl tracking-tight">EuroLaw Hub</span>
                        </Link>
                        <p className="mt-4 text-sm text-[#F5F0E8]/80 leading-relaxed max-w-xs">
                            {T(
                                "EU legal research workspace for qualified counsel. Citation-grounded. Decision support, not a substitute for qualified legal advice.",
                                "Hukukçular için AB hukuku araştırma platformu. Atıf temellidir. Karar desteğidir; nitelikli hukuki danışmanlığın yerini tutmaz."
                            )}
                        </p>
                        <p className="mt-4 text-sm">
                            <a href="mailto:altay@eurolawhub.com" className="text-[#F5F0E8]/80 hover:text-[#C9A84C]"
                                data-testid="footer-contact-email">
                                altay@eurolawhub.com
                            </a>
                        </p>
                    </div>

                    {COLUMNS.map((col) => (
                        <div key={col.title} data-testid={col.testid}>
                            <div className="text-[10px] font-semibold uppercase tracking-[0.24em] text-[#C9A84C]">
                                {T(col.title, col.tr)}
                            </div>
                            <ul className="mt-4 space-y-2">
                                {col.items.map((it) => (
                                    <li key={it.to + it.label}>
                                        <Link to={it.to} className="text-sm text-[#F5F0E8]/80 hover:text-[#C9A84C]">
                                            {T(it.label, it.tr)}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                            {col.title === "Legal" && (
                                <button
                                    type="button"
                                    onClick={openCookiePreferences}
                                    className="text-[#F5F0E8]/80 hover:text-[#C9A84C] text-sm text-left mt-2"
                                    data-testid="footer-cookie-preferences"
                                >
                                    {T("Cookie preferences", "Çerez tercihleri")}
                                </button>
                            )}
                        </div>
                    ))}
                </div>

                <div className="mt-10 pt-6 border-t border-[#F5F0E8]/15 text-xs text-[#F5F0E8]/55 flex items-center justify-between gap-4 flex-wrap">
                    <span>© {year} EuroLaw Hub. {T("All rights reserved.", "Tüm hakları saklıdır.")}</span>
                    <LangSwitcher dark testId="footer-lang-switcher" />
                </div>
            </div>
        </footer>
    );
}
